t = require('views/internal/teacup-with-helpers')('search_suggetion_member')
memberTemplate = require './member'

module.exports = ->
  t.a '.search-suggestion.search-suggestion-member.js-select-suggestion', { href: '#', 'data-suggestionphrase': t.mustacheVar('phrase') }, ->
    t.span '.member.search-suggestion-member-av', ->
      memberTemplate t.mustacheVar('.')
    t.span ->
      t.format 'cards-assigned-to-fullname', { fullName: t.mustacheVar('fullName') }, { raw: true }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/search_suggetion_member.coffee